import { api } from '@/lib/api'

export const CUSTOMER_IMPORT_TEMPLATE = [
  'name,phone,gender,email,allergies,marketing_consent,notes,blacklist',
  'Jane Guest,501112223,ladies,jane@example.test,,yes,,no',
].join('\n')

export const SERVICE_IMPORT_TEMPLATE = [
  'name,category,duration,price_ladies,price_gents,name_ar,skill_level,bookable_online,is_active',
  'Sample Blow Dry,Hair,45,150,120,,standard,yes,yes',
].join('\n')

/**
 * @param {string} filename
 * @param {string} content
 */
export function downloadCsvTemplate(filename, content) {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}

/**
 * @param {File} file
 * @returns {Promise<{ created: number, updated: number, failed: number, errors: Array<{ line: number, message: string }> }>}
 */
export async function importCustomersCsv(file) {
  const formData = new FormData()
  formData.append('file', file)
  const { data } = await api.post('/masters/customers/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data.data.summary
}

/**
 * @param {File} file
 * @returns {Promise<{ created: number, updated: number, failed: number, errors: Array<{ line: number, message: string }> }>}
 */
export async function importServicesCsv(file) {
  const formData = new FormData()
  formData.append('file', file)
  const { data } = await api.post('/masters/services/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data.data.summary
}
